var _asyncToGenerator = require("/Users/milespeyton/Documents/github/spiky/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

var Mutex = require('async-mutex').Mutex;

var _require = require('json-rpc-engine'),
    createAsyncMiddleware = _require.createAsyncMiddleware;

var createJsonRpcMiddleware = require('eth-json-rpc-middleware/scaffold');

var LogFilter = require('./log-filter.js');

var BlockFilter = require('./block-filter.js');

var TxFilter = require('./tx-filter.js');

var _require2 = require('./hexUtils'),
    intToHex = _require2.intToHex,
    hexToInt = _require2.hexToInt;

module.exports = createEthFilterMiddleware;

function createEthFilterMiddleware(_ref) {
  var blockTracker = _ref.blockTracker,
      provider = _ref.provider;
  // create filter collection
  var filterIndex = 0;
  var filters = {}; // create update mutex

  var mutex = new Mutex();
  var waitForFree = mutexMiddlewareWrapper({
    mutex: mutex
  });
  var middleware = createJsonRpcMiddleware({
    // install filters
    eth_newFilter: waitForFree(toFilterCreationMiddleware(newLogFilter)),
    eth_newBlockFilter: waitForFree(toFilterCreationMiddleware(newBlockFilter)),
    eth_newPendingTransactionFilter: waitForFree(toFilterCreationMiddleware(newPendingTransactionFilter)),
    // uninstall filters
    eth_uninstallFilter: waitForFree(toAsyncRpcMiddleware(uninstallFilterHandler)),
    // checking filter changes
    eth_getFilterChanges: waitForFree(toAsyncRpcMiddleware(getFilterChanges)),
    eth_getFilterLogs: waitForFree(toAsyncRpcMiddleware(getFilterLogs))
  }); // setup filter updating and destroy handler

  var filterUpdater = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref2) {
      var oldBlock, newBlock, releaseLock;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              oldBlock = _ref2.oldBlock, newBlock = _ref2.newBlock;

              if (!(filters.length === 0)) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt("return");

            case 3:
              _context2.next = 5;
              return mutex.acquire();

            case 5:
              releaseLock = _context2.sent;
              _context2.prev = 6;
              _context2.next = 9;
              return Promise.all(objValues(filters).map( /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(filter) {
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.prev = 0;
                          _context.next = 3;
                          return filter.update({
                            oldBlock: oldBlock,
                            newBlock: newBlock
                          });

                        case 3:
                          _context.next = 8;
                          break;

                        case 5:
                          _context.prev = 5;
                          _context.t0 = _context["catch"](0);
                          // handle each error individually so filter update errors don't affect other filters
                          console.error(_context.t0);

                        case 8:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, null, [[0, 5]]);
                }));

                return function (_x2) {
                  return _ref4.apply(this, arguments);
                };
              }()));

            case 9:
              _context2.next = 14;
              break;

            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](6);
              // log error so we don't skip the releaseLock
              console.error(_context2.t0);

            case 14:
              // unlock update reads
              releaseLock();

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[6, 11]]);
    }));

    return function filterUpdater(_x) {
      return _ref3.apply(this, arguments);
    };
  }(); // expose filter methods directly


  middleware.newLogFilter = newLogFilter;
  middleware.newBlockFilter = newBlockFilter;
  middleware.newPendingTransactionFilter = newPendingTransactionFilter;
  middleware.uninstallFilter = uninstallFilterHandler;
  middleware.getFilterChanges = getFilterChanges;
  middleware.getFilterLogs = getFilterLogs; // expose destroy method for cleanup

  middleware.destroy = function () {
    uninstallAllFilters();
  };

  return middleware; //
  // new filters
  //

  function newLogFilter(_x3) {
    return _newLogFilter.apply(this, arguments);
  }

  function _newLogFilter() {
    _newLogFilter = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(params) {
      var filter, filterIndex;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              filter = new LogFilter({
                provider: provider,
                params: params
              });
              _context3.next = 3;
              return installFilter(filter);

            case 3:
              filterIndex = _context3.sent;
              return _context3.abrupt("return", filter);

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return _newLogFilter.apply(this, arguments);
  }

  function newBlockFilter() {
    return _newBlockFilter.apply(this, arguments);
  }

  function _newBlockFilter() {
    _newBlockFilter = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var filter, filterIndex;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              filter = new BlockFilter({
                provider: provider
              });
              _context4.next = 3;
              return installFilter(filter);

            case 3:
              filterIndex = _context4.sent;
              return _context4.abrupt("return", filter);

            case 5:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    return _newBlockFilter.apply(this, arguments);
  }

  function newPendingTransactionFilter() {
    return _newPendingTransactionFilter.apply(this, arguments);
  } //
  // get filter changes
  //


  function _newPendingTransactionFilter() {
    _newPendingTransactionFilter = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      var filter, filterIndex;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              filter = new TxFilter({
                provider: provider
              });
              _context5.next = 3;
              return installFilter(filter);

            case 3:
              filterIndex = _context5.sent;
              return _context5.abrupt("return", filter);

            case 5:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));
    return _newPendingTransactionFilter.apply(this, arguments);
  }

  function getFilterChanges(_x4) {
    return _getFilterChanges.apply(this, arguments);
  }

  function _getFilterChanges() {
    _getFilterChanges = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(filterIndexHex) {
      var filterIndex, filter, results;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              filterIndex = hexToInt(filterIndexHex);
              filter = filters[filterIndex];

              if (filter) {
                _context6.next = 4;
                break;
              }

              throw new Error("No filter for index \"".concat(filterIndex, "\""));

            case 4:
              results = filter.getChangesAndClear();
              return _context6.abrupt("return", results);

            case 6:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));
    return _getFilterChanges.apply(this, arguments);
  }

  function getFilterLogs(_x5) {
    return _getFilterLogs.apply(this, arguments);
  } //
  // remove filters
  //


  function _getFilterLogs() {
    _getFilterLogs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(filterIndexHex) {
      var filterIndex, filter;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              filterIndex = hexToInt(filterIndexHex);
              filter = filters[filterIndex];

              if (filter) {
                _context7.next = 4;
                break;
              }

              throw new Error("No filter for index \"".concat(filterIndex, "\""));

            case 4:
              // only return results for log filters
              if (filter.type === 'log') {
                results = filter.getAllResults();
              } else {
                results = [];
              }

              return _context7.abrupt("return", results);

            case 6:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));
    return _getFilterLogs.apply(this, arguments);
  }

  function uninstallFilterHandler(_x6) {
    return _uninstallFilterHandler.apply(this, arguments);
  } //
  // utils
  //


  function _uninstallFilterHandler() {
    _uninstallFilterHandler = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(filterIndexHex) {
      var filterIndex, filter, result;
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              // check filter exists
              filterIndex = hexToInt(filterIndexHex);
              filter = filters[filterIndex];
              result = Boolean(filter); // uninstall filter

              if (!result) {
                _context8.next = 6;
                break;
              }

              _context8.next = 6;
              return uninstallFilter(filterIndex);

            case 6:
              return _context8.abrupt("return", result);

            case 7:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));
    return _uninstallFilterHandler.apply(this, arguments);
  }

  function installFilter(_x7) {
    return _installFilter.apply(this, arguments);
  }

  function _installFilter() {
    _installFilter = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(filter) {
      var prevFilterCount, currentBlock, newFilterCount;
      return _regeneratorRuntime().wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              prevFilterCount = objValues(filters).length; // install filter

              _context9.next = 3;
              return blockTracker.getLatestBlock();

            case 3:
              currentBlock = _context9.sent;
              _context9.next = 6;
              return filter.initialize({
                currentBlock: currentBlock
              });

            case 6:
              filterIndex++;
              filters[filterIndex] = filter;
              filter.id = filterIndex;
              filter.idHex = intToHex(filterIndex); // update block tracker subs

              newFilterCount = objValues(filters).length;
              updateBlockTrackerSubs({
                prevFilterCount: prevFilterCount,
                newFilterCount: newFilterCount
              });
              return _context9.abrupt("return", filterIndex);

            case 13:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));
    return _installFilter.apply(this, arguments);
  }

  function uninstallFilter(_x8) {
    return _uninstallFilter.apply(this, arguments);
  }

  function _uninstallFilter() {
    _uninstallFilter = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(filterIndex) {
      var prevFilterCount, newFilterCount;
      return _regeneratorRuntime().wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              prevFilterCount = objValues(filters).length;
              delete filters[filterIndex]; // update block tracker subs

              newFilterCount = objValues(filters).length;
              updateBlockTrackerSubs({
                prevFilterCount: prevFilterCount,
                newFilterCount: newFilterCount
              });

            case 4:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));
    return _uninstallFilter.apply(this, arguments);
  }

  function uninstallAllFilters() {
    return _uninstallAllFilters.apply(this, arguments);
  }

  function _uninstallAllFilters() {
    _uninstallAllFilters = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
      var prevFilterCount;
      return _regeneratorRuntime().wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              prevFilterCount = objValues(filters).length;
              filters = {}; // update block tracker subs

              updateBlockTrackerSubs({
                prevFilterCount: prevFilterCount,
                newFilterCount: 0
              });

            case 3:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }));
    return _uninstallAllFilters.apply(this, arguments);
  }

  function updateBlockTrackerSubs(_ref5) {
    var prevFilterCount = _ref5.prevFilterCount,
        newFilterCount = _ref5.newFilterCount;

    // subscribe
    if (prevFilterCount === 0 && newFilterCount > 0) {
      blockTracker.on('sync', filterUpdater);
      return;
    } // unsubscribe


    if (prevFilterCount > 0 && newFilterCount === 0) {
      blockTracker.removeListener('sync', filterUpdater);
      return;
    }
  }
} // helper for turning filter constructors into rpc middleware


function toFilterCreationMiddleware(createFilterFn) {
  return toAsyncRpcMiddleware( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
    var filter,
        result,
        _args12 = arguments;
    return _regeneratorRuntime().wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _context12.next = 2;
            return createFilterFn.apply(void 0, _args12);

          case 2:
            filter = _context12.sent;
            result = intToHex(filter.id);
            return _context12.abrupt("return", result);

          case 5:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  })));
} // helper for pulling out req.params and setting res.result


function toAsyncRpcMiddleware(asyncFn) {
  return createAsyncMiddleware( /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(req, res) {
      var result;
      return _regeneratorRuntime().wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return asyncFn.apply(null, req.params);

            case 2:
              result = _context13.sent;
              res.result = result;

            case 4:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13);
    }));

    return function (_x9, _x10) {
      return _ref7.apply(this, arguments);
    };
  }());
}

function mutexMiddlewareWrapper(_ref8) {
  var mutex = _ref8.mutex;
  return function (middleware) {
    return /*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(req, res, next, end) {
        var releaseLock;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return mutex.acquire();

              case 2:
                releaseLock = _context14.sent;
                releaseLock();
                middleware(req, res, next, end);

              case 5:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14);
      }));

      return function (_x11, _x12, _x13, _x14) {
        return _ref9.apply(this, arguments);
      };
    }();
  };
}

function objValues(obj, fn) {
  var values = [];

  for (var key in obj) {
    values.push(obj[key]);
  }

  return values;
}